module.exports = __webpack_public_path__ + "fonts/avenir/1cda1791-25c1-48d3-9056-3b04b763b592.svg";


//////////////////
// WEBPACK FOOTER
// ./fonts/avenir/1cda1791-25c1-48d3-9056-3b04b763b592.svg
// module id = 46
// module chunks = 0